import React from 'react';

const CustomLabel = (props: { label: string; truncate?: boolean }) => {
  const { label, truncate } = props;
  return (
    <label
      className={`block ${
        truncate && 'truncate'
      } text-[15px] text-0color leading-[109%] tracking-[-0.03em] font-[500]`}
    >
      {label}
    </label>
  );
};

export default CustomLabel;
